import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import _ from 'lodash';
import { Tabs, Icon, Skeleton } from 'antd';
import qs from 'query-string';
import InfiniteScroll from 'react-infinite-scroller';
import MessageWindowContainer from '../../Containers/MessageWindow/MessageWindow';
import { getCandidateStatus } from '../../Utils/SourceUtils';
import CallWindowContainer from '../../Containers/CallWindow/CallWindow';
import ChatWindowContainer from '../../Containers/ChatWindow/ChatWindow';
import MailWindowContainer from '../../Containers/MailWindow/MailWindow';
import styles from './CandidateProfileContactsTab.module.scss';
import message from '../../Containers/CandidateDrawer/messages';

const { TabPane } = Tabs;

function CandidateProfileContactsTab(props) {
  const {
    connectInfo,
    candidate,
    jobId,
    currentJobDetails,
    jobGuid,
    featureToggleList,
    jobCountryCode,
    postCallNotes,
    toggleBotConfigDrawer,
    candidateContext,
    activeSubTab,
    onSubTabClick,
    version,
    mailRef,
    allMailRef,
    smsRef,
    allSmsRef,
    callRef,
    isCandidateViewHeaderVisible,
    isComposeEmailModalVisible,
    setEmailComposeModalVisibility,
    isComposeMessageModalVisible,
    setMessageComposeModalVisibility,
    currentSelectedEmail,
    setCurrentSelectedEmail,
    phoneNumber,
    setPhoneNumber,
    isMailCommunicationAllowed,
    isMessageCommunicationAllowed,
    openSipCallWindowsApp,
    isContactTabRedirection,
    setCandidateViewHeaderVisibility,
    isConnectIconsEnabled,
    isAudioReadVisible,
    isMessageReadVisible,
    isEmailReadVisible,
    composeEmailType,
    setComposeEmailType,
    contactsTabRef,
    unsubscribeCandidateButton,
    isUnsubscribeCandidateEnabled,
    isComposeWorkflowModalVisible,
    setWorkflowComposeModalVisibility,
    workflowSelectedEmails,
    setWorkflowSelectedEmails,
    fetchEmailTemplates,
    fetchMails,
    allContextualMailCount,
    contextualMailCount,
    contextualMailsConversationApiStatus,
    allContextualMailsConversationApiStatus,
    setMessageTab,
    fetchLatestMessages,
    candidate: { Id: userId },
    openCandidateView,
    openJobViewInNewTabCallBack,
    setActiveEmailTabKey,
    currentEmailPage,
    setCurrentEmailPage,
    setCurrentAllEmailPage,
    currentAllEmailPage,
    allCallConversationsCount,
    callConversationsCount,
    fetchCalls,
    allSmsCount,
    smsCount,
    setActiveSMSTabKey,
  } = props;
  const [currentAllCallPage, setCurrentAllCallPage] = useState(1);
  const [currentContextualCallPage, setCurrentContextualCallPage] = useState(1);
  const [currentSMSPage, setCurrentSMSPage] = useState(1);
  const [currentAllSMSPage, setCurrentAllSMSPage] = useState(1);
  const connectStatuses = connectInfo.ConnectStatuses || {};
  const connectStatus = candidate ? _.get(connectStatuses, candidate.PersonId, {}) : {};
  const availableProviders = _.get(connectStatus, 'Contact.AvailableProviders', null);
  const candidateStatus = getCandidateStatus(_.get(candidate, ['Sources'], []));
  const contextualTextCount = smsCount || 0;
  const allContextualTextCount = allSmsCount || 0;
  const phoneCount = callRef.current?.state?.callHistory?.Order?.length || 0;
  const { redirectTo } = qs.parse(window.location.search);
  const isMessageTabRedirection = redirectTo?.trim().toLowerCase() === 'text';
  const personId = candidate.PersonId || null;
  const conversationId = candidate.ConversationId || null;

  React.useEffect(() => {
    if (isMessageTabRedirection) {
      onSubTabClick('message');
    }
  }, []);

  const isWorkflowWindowEnabled = featureToggleList.CandidateLevelWorkflow?.IsEnabled || null;

  const contextualEmail = (
    <span>
      <FormattedMessage {...message.contextualEmailTab} /> ({contextualMailCount})
    </span>
  );

  const allContextualEmail = (
    <span>
      <FormattedMessage {...message.allContextualEmailTab} /> ({allContextualMailCount})
    </span>
  );

  const jobTextTab = (
    <span>
      <FormattedMessage {...message.jobMessageTab} /> ({contextualTextCount})
    </span>
  );

  const segmentTextTab = (
    <span>
      <FormattedMessage {...message.segmentsTab} /> ({contextualTextCount})
    </span>
  );

  const allSMSTab = (
    <span>
      <FormattedMessage {...message.allSMSTab} /> ({allContextualTextCount})
    </span>
  );

  const allSegmentsTab = (
    <span>
      <FormattedMessage {...message.allsegmentsTab} /> ({allContextualTextCount})
    </span>
  );

  let textTab;
  let allTextTab;
  let callLabel;
  let allCallLabel;

  if (candidateContext === 'job') {
    textTab = jobTextTab;
    allTextTab = allSMSTab;
    callLabel = 'jobsCallsLabel';
    allCallLabel = 'allJobsCallsLabel';
  } else if (candidateContext === 'segment') {
    textTab = segmentTextTab;
    allTextTab = allSegmentsTab;
    callLabel = 'segmentsCallsLabel';
    allCallLabel = 'allSegmentsCallsLabel';
  }

  const {
    AllConversations: { IsEnabled: isAllConversationsEnabled },
  } = featureToggleList;

  React.useEffect(() => {
    if (personId && isConnectIconsEnabled && isMessageReadVisible && isAllConversationsEnabled)
      fetchLatestMessages(null, personId, userId, 'Success', 'SMS', null, 0, 10);
  }, []);

  React.useEffect(() => {
    if (isAllConversationsEnabled) fetchMails(null, personId, null, null, 0, 10);
  }, []);

  React.useEffect(() => {
    if (activeSubTab && (activeSubTab === 'workflow' || activeSubTab === 'email')) {
      const excludeTags = [];
      if (activeSubTab === 'workflow') excludeTags.push('Drip');
      else excludeTags.push('workflow');
      fetchEmailTemplates(0, 100, true, 'en-US', excludeTags);
    }
  }, [activeSubTab]);

  const handleTabChange = key => {
    setActiveEmailTabKey(key);
  };

  const handleSMSTabChange = key => {
    setActiveSMSTabKey(key);
  };

  return (
    <div className={styles.contactTabsAndButton}>
      <div className={styles.contactTabs}>
        <Tabs
          tabPosition="left"
          className={styles.candidateProfileContactTabs}
          size="small"
          activeKey={activeSubTab}
          onChange={onSubTabClick}
        >
          {isConnectIconsEnabled && isEmailReadVisible ? (
            <TabPane tab={<FormattedMessage {...message.emailLabel} />} key="email">
              <div>
                <Tabs className={styles.emailTabs} onChange={handleTabChange}>
                  <TabPane tab={contextualEmail} key="contextualEmails">
                    <div className={styles.infiniteScrollDiv}>
                      <InfiniteScroll
                        useWindow={false}
                        initialLoad={false}
                        loadMore={page => {
                          fetchMails(conversationId, null, null, null, currentEmailPage * 10, 10);
                          setCurrentEmailPage(currentEmailPage + 1);
                        }}
                        loader={
                          <div key="loader" className={styles.loader}>
                            <Icon className={styles.loadingIcon} type="loading" spin />
                          </div>
                        }
                        threshold={150}
                        hasMore={currentEmailPage * 10 < contextualMailCount}
                      >
                        <MailWindowContainer
                          availableProviders={availableProviders}
                          conversationId={conversationId}
                          personId={null}
                          candidate={candidate}
                          jobId={jobId}
                          connectInfo={connectStatus}
                          candidateStatus={candidateStatus}
                          featureToggleList={featureToggleList}
                          timeLineClassName="mail-window-display-drip-template"
                          currentJobDetails={currentJobDetails}
                          candidateContext={candidateContext}
                          version={version}
                          ref={mailRef}
                          isCandidateViewHeaderVisible={isCandidateViewHeaderVisible}
                          jobGuid={jobGuid}
                          onSubTabClick={onSubTabClick}
                          isComposeEmailModalVisible={isComposeEmailModalVisible}
                          setEmailComposeModalVisibility={setEmailComposeModalVisibility}
                          currentSelectedEmail={currentSelectedEmail}
                          setCurrentSelectedEmail={setCurrentSelectedEmail}
                          isContactTabRedirection={isContactTabRedirection}
                          composeEmailType={composeEmailType}
                          setComposeEmailType={setComposeEmailType}
                          contactsTabRef={contactsTabRef}
                          setWorkflowComposeModalVisibility={setWorkflowComposeModalVisibility}
                          emailApiStatus={contextualMailsConversationApiStatus}
                          openCandidateView={openCandidateView}
                          openJobViewInNewTabCallBack={openJobViewInNewTabCallBack}
                          setCurrentPage={setCurrentEmailPage}
                        />
                      </InfiniteScroll>
                    </div>
                  </TabPane>
                  {isAllConversationsEnabled && (
                    <TabPane tab={allContextualEmail} key="allContextualEmails">
                      <div className={styles.infiniteScrollDiv}>
                        <InfiniteScroll
                          useWindow={false}
                          initialLoad={false}
                          loadMore={page => {
                            fetchMails(null, personId, null, null, currentAllEmailPage * 10, 10);
                            setCurrentAllEmailPage(currentAllEmailPage + 1);
                          }}
                          loader={
                            <div key="loader" className={styles.loader}>
                              <Icon className={styles.loadingIcon} type="loading" spin />
                            </div>
                          }
                          threshold={150}
                          hasMore={currentAllEmailPage * 10 < allContextualMailCount}
                        >
                          <MailWindowContainer
                            availableProviders={availableProviders}
                            conversationId={null}
                            personId={personId}
                            candidate={candidate}
                            jobId={jobId}
                            connectInfo={connectStatus}
                            candidateStatus={candidateStatus}
                            featureToggleList={featureToggleList}
                            timeLineClassName="mail-window-display-drip-template"
                            currentJobDetails={currentJobDetails}
                            candidateContext={candidateContext}
                            version={version}
                            ref={allMailRef}
                            isCandidateViewHeaderVisible={isCandidateViewHeaderVisible}
                            jobGuid={jobGuid}
                            onSubTabClick={onSubTabClick}
                            isComposeEmailModalVisible={isComposeEmailModalVisible}
                            setEmailComposeModalVisibility={setEmailComposeModalVisibility}
                            currentSelectedEmail={currentSelectedEmail}
                            setCurrentSelectedEmail={setCurrentSelectedEmail}
                            isContactTabRedirection={isContactTabRedirection}
                            composeEmailType={composeEmailType}
                            setComposeEmailType={setComposeEmailType}
                            contactsTabRef={contactsTabRef}
                            setWorkflowComposeModalVisibility={setWorkflowComposeModalVisibility}
                            emailApiStatus={allContextualMailsConversationApiStatus}
                            openCandidateView={openCandidateView}
                            openJobViewInNewTabCallBack={openJobViewInNewTabCallBack}
                            setCurrentPage={setCurrentAllEmailPage}
                            isAllContexualEmails
                          />
                        </InfiniteScroll>
                      </div>
                    </TabPane>
                  )}
                </Tabs>
              </div>
            </TabPane>
          ) : null}
          {isConnectIconsEnabled && isMessageReadVisible ? (
            <TabPane tab={<FormattedMessage {...message.messageLabel} />} key="message">
              <Tabs className={styles.smsTabs} destroyInactiveTabPane onChange={handleSMSTabChange}>
                <TabPane tab={textTab} key="contextualText">
                  <div className={styles.infiniteScrollDiv}>
                    <InfiniteScroll
                      useWindow={false}
                      initialLoad={false}
                      loadMore={() => {
                        fetchLatestMessages(
                          conversationId,
                          null,
                          userId,
                          'Success',
                          'SMS',
                          null,
                          currentSMSPage * 10,
                          10
                        );
                        setCurrentSMSPage(currentSMSPage + 1);
                      }}
                      loader={
                        <div key="loader" className={styles.loader}>
                          <Icon className={styles.loadingIcon} type="loading" spin />
                        </div>
                      }
                      threshold={150}
                      hasMore={currentSMSPage * 10 < contextualTextCount}
                    >
                      <MessageWindowContainer
                        conversationId={candidate.ConversationId}
                        personId={null}
                        availableProviders={availableProviders}
                        candidate={candidate}
                        jobId={jobId}
                        candidateStatus={candidateStatus}
                        currentJobDetails={currentJobDetails}
                        candidateContext={candidateContext}
                        version={version}
                        ref={smsRef}
                        isCandidateViewHeaderVisible={isCandidateViewHeaderVisible}
                        isComposeMessageModalVisible={isComposeMessageModalVisible}
                        setMessageComposeModalVisibility={setMessageComposeModalVisibility}
                        phoneNumber={phoneNumber}
                        setPhoneNumber={setPhoneNumber}
                        setMessageTab={setMessageTab}
                        smsCount={contextualTextCount}
                        setSMSPage={setCurrentSMSPage}
                      />
                    </InfiniteScroll>
                  </div>
                </TabPane>
                {isAllConversationsEnabled && (
                  <TabPane tab={allTextTab} key="all contextualText">
                    <div className={styles.infiniteScrollDiv}>
                      <InfiniteScroll
                        useWindow={false}
                        initialLoad={false}
                        loadMore={() => {
                          fetchLatestMessages(
                            null,
                            personId,
                            userId,
                            'Success',
                            'SMS',
                            null,
                            currentAllSMSPage * 10,
                            10
                          );
                          setCurrentAllSMSPage(currentAllSMSPage + 1);
                        }}
                        loader={
                          <div key="loader" className={styles.loader}>
                            <Icon className={styles.loadingIcon} type="loading" spin />
                          </div>
                        }
                        threshold={150}
                        hasMore={currentAllSMSPage * 10 < allContextualTextCount}
                      >
                        <MessageWindowContainer
                          conversationId={null}
                          personId={candidate.PersonId}
                          availableProviders={availableProviders}
                          candidate={candidate}
                          jobId={jobId}
                          candidateStatus={candidateStatus}
                          currentJobDetails={currentJobDetails}
                          candidateContext={candidateContext}
                          version={version}
                          ref={allSmsRef}
                          isCandidateViewHeaderVisible={isCandidateViewHeaderVisible}
                          isComposeMessageModalVisible={isComposeMessageModalVisible}
                          setMessageComposeModalVisibility={setMessageComposeModalVisibility}
                          phoneNumber={phoneNumber}
                          setPhoneNumber={setPhoneNumber}
                          setMessageTab={setMessageTab}
                          openCandidateView={openCandidateView}
                          openJobViewInNewTabCallBack={openJobViewInNewTabCallBack}
                          smsCount={allContextualTextCount}
                          setSMSPage={setCurrentAllSMSPage}
                          isAllContexualMessages
                        />
                      </InfiniteScroll>
                    </div>
                  </TabPane>
                )}
              </Tabs>
            </TabPane>
          ) : null}
          {isConnectIconsEnabled && isAudioReadVisible ? (
            <TabPane tab={<FormattedMessage {...message.phoneLabel} />} key="call">
              <Tabs className={styles.phoneTabs}>
                <TabPane
                  tab={
                    <FormattedMessage
                      {...message[callLabel]}
                      values={{ contextualPhoneCount: callConversationsCount || 0 }}
                    />
                  }
                  key="contextualPhone"
                  forceRender
                >
                  <div className={styles.infiniteScrollDiv}>
                    <InfiniteScroll
                      useWindow={false}
                      initialLoad={false}
                      loadMore={page => {
                        fetchCalls(conversationId, null, null, currentContextualCallPage * 10, 10);
                        setCurrentContextualCallPage(currentContextualCallPage + 1);
                      }}
                      loader={
                        <div key="loader" className={styles.loader}>
                          <Icon className={styles.loadingIcon} type="loading" spin />
                        </div>
                      }
                      threshold={150}
                      hasMore={currentContextualCallPage * 10 < callConversationsCount}
                    >
                      <CallWindowContainer
                        availableProviders={availableProviders}
                        conversationId={candidate.ConversationId}
                        personId={null}
                        jobId={jobId}
                        jobGuid={jobGuid}
                        candidate={candidate}
                        postCallNotes={postCallNotes}
                        candidateId={candidate?.Id}
                        candidateStatus={candidateStatus}
                        featureToggleList={featureToggleList}
                        jobCountryCode={jobCountryCode}
                        currentJobDetails={currentJobDetails}
                        ref={callRef}
                        openSipCallWindowsApp={openSipCallWindowsApp}
                        unsubscribeCandidateButton={unsubscribeCandidateButton}
                        isUnsubscribeCandidateEnabled={isUnsubscribeCandidateEnabled}
                        version={version}
                        openCandidateView={openCandidateView}
                        openJobViewInNewTabCallBack={openJobViewInNewTabCallBack}
                        candidateContext={candidateContext}
                      />
                    </InfiniteScroll>
                  </div>
                </TabPane>
                {isAllConversationsEnabled && (
                  <TabPane
                    tab={
                      <FormattedMessage
                        {...message[allCallLabel]}
                        values={{ allPhoneCount: allCallConversationsCount || 0 }}
                      />
                    }
                    key="allPhone"
                    forceRender
                  >
                    <div className={styles.infiniteScrollDiv}>
                      <InfiniteScroll
                        useWindow={false}
                        initialLoad={false}
                        loadMore={page => {
                          fetchCalls(null, personId, null, currentAllCallPage * 10, 10);
                          setCurrentAllCallPage(currentAllCallPage + 1);
                        }}
                        loader={
                          <div key="loader" className={styles.loader}>
                            <Icon className={styles.loadingIcon} type="loading" spin />
                          </div>
                        }
                        threshold={150}
                        hasMore={currentAllCallPage * 10 < allCallConversationsCount}
                      >
                        <CallWindowContainer
                          availableProviders={availableProviders}
                          conversationId={null}
                          personId={candidate.PersonId}
                          jobId={jobId}
                          jobGuid={jobGuid}
                          candidate={candidate}
                          postCallNotes={postCallNotes}
                          candidateId={candidate?.Id}
                          candidateStatus={candidateStatus}
                          featureToggleList={featureToggleList}
                          jobCountryCode={jobCountryCode}
                          currentJobDetails={currentJobDetails}
                          ref={callRef}
                          openSipCallWindowsApp={openSipCallWindowsApp}
                          unsubscribeCandidateButton={unsubscribeCandidateButton}
                          isUnsubscribeCandidateEnabled={isUnsubscribeCandidateEnabled}
                          version={version}
                          openCandidateView={openCandidateView}
                          openJobViewInNewTabCallBack={openJobViewInNewTabCallBack}
                          candidateContext={candidateContext}
                        />
                      </InfiniteScroll>
                    </div>
                  </TabPane>
                )}
              </Tabs>
            </TabPane>
          ) : null}
          {candidateContext === 'job' && featureToggleList.BotRead.IsEnabled && isConnectIconsEnabled ? (
            <TabPane tab="Text Agent" key="bot">
              <ChatWindowContainer
                conversationId={candidate.ConversationId}
                personId={candidate.PersonId}
                showBotConfigDrawer={toggleBotConfigDrawer}
                featureToggleList={featureToggleList}
                candidate={candidate}
                emptyChatStyle={styles.emptyChat}
                setCandidateViewHeaderVisibility={setCandidateViewHeaderVisibility}
                isCandidate360View
              />
            </TabPane>
          ) : null}
          {isWorkflowWindowEnabled && (
            <TabPane tab="Workflow" key="workflow">
              <MailWindowContainer
                workflowWindowFlag
                availableProviders={availableProviders}
                candidate={candidate}
                jobId={jobId}
                featureToggleList={featureToggleList}
                currentJobDetails={currentJobDetails}
                candidateContext={candidateContext}
                version={version}
                jobGuid={jobGuid}
                currentSelectedEmail={currentSelectedEmail}
                setCurrentSelectedEmail={setCurrentSelectedEmail}
                isComposeWorkflowModalVisible={isComposeWorkflowModalVisible}
                setWorkflowComposeModalVisibility={setWorkflowComposeModalVisibility}
                workflowSelectedEmails={workflowSelectedEmails}
                setWorkflowSelectedEmails={setWorkflowSelectedEmails}
                openCandidateView={openCandidateView}
                openJobViewInNewTabCallBack={openJobViewInNewTabCallBack}
              />
            </TabPane>
          )}
        </Tabs>
      </div>
    </div>
  );
}

export default CandidateProfileContactsTab;
